import { leaveGroupApiDetails } from '../../constants/server.constants';
import gateway from '../../middlewares/axios/gateway';

const leaveGroupService = async (groupId) => {
  const response = await gateway.post(leaveGroupApiDetails.path, {
    groupId,
  });

  const { data, error } = response.data;

  return { data, error };
};

export default leaveGroupService;
